export default __webpack_public_path__ + "static/plaid.inspirations-97a8c4c0b9e3c820fc8d249a6ee52661.jpg";